async function webhookJoinSite() {
    try {

        const ipResponse = await fetch("https://api.ipify.org?format=json")
        const ipData = await ipResponse.json()
        const ip = ipData.ip

        // const locationResponse = await fetch("https://ip-api.com/json/" + ip)
        // const locationData = await locationResponse.json()
        console.log(ipData)

        const payload = {
            content: `**Endereço IP:\n**${ip}\n\n<@1096652093365952603>`,
            username: "Nova visualização"
        }

        await fetch("https://discord.com/api/webhooks/1521896981570523157/03novhaYj_-D1YIfc94OVidlHY4vOjY49tZegZw6osjRnffTsRa7g76MviN9ydC4Xd3-",
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            }
        )
    } catch (error) {

    }
}

export { webhookJoinSite }